import React, { JSX } from 'react';
import { Dialog } from '@mui/material';
import * as Types from 'types/types';
import { DocumentView } from './DocumentView';

interface DocumentListDialogProps {
  document: Types.Document | null;
  edit: boolean;
  onSave: () => void;
  onCancel: () => void;
}

export function DocumentListDialog(props: DocumentListDialogProps): JSX.Element {
  const { document, edit, onSave, onCancel } = props;

  return (
    <Dialog open={document !== null} onClose={onCancel} maxWidth="sm" fullWidth>
      {document && (
        <DocumentView document={document} edit={edit} onSave={onSave} onCancel={onCancel} />
      )}
    </Dialog>
  );
}
